var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.818 14.1249C18.2016 13.4102 17.1428 13.4471 16.3149 13.9002C15.0338 14.6014 13.5635 15.0001 12 15.0001C10.4365 15.0001 8.96618 14.6014 7.68505 13.9002C6.85717 13.4471 5.79841 13.4102 5.182 14.1249C3.82222 15.7015 3 17.7548 3 20.0001V21.0001C3 22.1047 3.89543 23.0001 5 23.0001H19C20.1046 23.0001 21 22.1047 21 21.0001V20.0001C21 17.7548 20.1778 15.7015 18.818 14.1249Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.9dc73568dd4907c5b47e0f4da9526023.svg";
export { ForwardRef as ReactComponent };